export default "__VITE_ASSET__6fb97108__"